export default class TokenManager {
    static getToken() {
        return localStorage.getItem('token');
    }

    static getExpiresAt() {
        return localStorage.getItem('token_expires_at');
    }

    static setTokenInfo(data) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('token_expires_at', data.token_expires_at);
        localStorage.setItem('userId', data.user_id);
        localStorage.setItem('username', data.username);
    }

    static clearToken() {
        localStorage.removeItem('token');
        localStorage.removeItem('token_expires_at');
        localStorage.removeItem('userId');
        localStorage.removeItem('username');
    }
    // 判断token是否即将过期，30分钟
    static isExpiringSoon(minutes = 30) {
        const expiresAt = this.getExpiresAt();
        if (!expiresAt) return false;

        const now = Math.floor(Date.now() / 1000);
        const timeToExpire = expiresAt - now;
        return timeToExpire < (minutes * 60);
    }
}
